import { getRoot } from 'mobx-state-tree';
const Views = self => ({
    shouldShowBulkUBP: () => { var _a, _b, _c; return (_c = (_b = (_a = getRoot(self).user) === null || _a === void 0 ? void 0 : _a.billing) === null || _b === void 0 ? void 0 : _b.isPaid) !== null && _c !== void 0 ? _c : false; },
    isEligibleForBulkShow: () => !self.shouldShowBulkUBP() || self.bulkShowCredits > 0,
});
export default Views;
